



































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import GuiaTissSadt from '@/template/backoffice/GuiaTissSadt.vue'
import GuiaTissInternacao from '@/template/backoffice/GuiaTissInternacao.vue'
import GuiaTissOpme from '@/template/backoffice/GuiaTissOpme.vue'
import { pdfService } from '@/services/pdf.service'
import { TipoDocumentoUpload } from '@/types/_'
import { blobToFile, timeout } from '@/utils/common'
import EventBus from '@/plugins/EventBus'

@Component({
  components: {
    GuiaTissSadt,
    GuiaTissOpme,
    GuiaTissInternacao,
  },
})
export default class ComponentBackofficeGerarGuias extends Vue {
  @Prop({ default: false }) disabled: boolean
  @Prop({ default: true }) show: boolean

  $refs!: {
    guiaTissSadt: any,
    guiaTissInternacao: any,
    guiaTissOpme: any,
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  loadingGuiaInternacao: boolean = false
  loadingPedidoSemAssinatura: boolean = false
  loadingTissSadtPDFCreation: boolean = false
  loadingGuiaTissInternacao: boolean = false
  loadingGuiaTissOpme: boolean = false
  showTissSadtInfo: boolean = false

  async gerarGuias(data:any) {
    this.loadingGuiaInternacao = true
    const response = await this.getBackofficeGlobalStore.gerarGuias(data)
    if (response.success) {
      await timeout(2000)
      EventBus.$emit('setSnackbar', { show: true, text: 'Guia gerada com sucesso! Atualize a página para visualizar o seu documento.', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Não foi possivel gerar a guia de internação', icon: 'warning', color: '#C62828' })
    }
    this.loadingGuiaInternacao = false
  }


  async gerarPedidoSemAssinatura() {
    this.loadingPedidoSemAssinatura = true
    const response = await this.getBackofficeGlobalStore.gerarPedidoSemAssinatura(this.getBackofficeGlobalStore.solicitacao.id)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Pedido gerado com sucesso! Atualize a página para visualizar o seu documento.', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Não foi possivel gerar o pedido sem assinatura', icon: 'warning', color: '#C62828' })
    }
    this.loadingPedidoSemAssinatura = false
  }

  async generateTissSadtPDF() {
    try {
      this.loadingTissSadtPDFCreation = true

      const doctorSignatureAPIResponse = await this.getBackofficeGlobalStore.getDoctorSignature(this.getBackofficeGlobalStore.solicitacao.medicoSolicitanteId)

      if (doctorSignatureAPIResponse.success && !!this.getBackofficeGlobalStore.solicitacao.medicoSolicitante.assinatura) {
        this.$forceUpdate()

        const tempContainer = document.createElement('div')
        tempContainer.style.position = 'absolute'
        tempContainer.style.top = '-9999px'
        tempContainer.style.left = '-9999px'

        document.body.appendChild(tempContainer)

        const TissSadtComponent = this.$refs.guiaTissSadt

        TissSadtComponent.$el.style.display = 'block'
        tempContainer.appendChild(TissSadtComponent.$el)

        const TissSadtContent = TissSadtComponent.$el
        const { paciente, medicoSolicitante } = this.getBackofficeGlobalStore.solicitacao

        await pdfService.generateFromReferenceElement(TissSadtContent, {
          orientation: 'landscape',
          fileName: `GuiaSADT-Paciente/${paciente.nome}-Medico/${medicoSolicitante.nome}`,
        })

        document.body.removeChild(tempContainer)
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: doctorSignatureAPIResponse.message || 'Não foi possível buscar assinatura do médico', icon: 'warning', color: '#C62828' })
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao gerar PDF - Guia TISS SADT', icon: 'warning', color: '#C62828' })
    } finally {
      this.loadingTissSadtPDFCreation = false
    }
  }

  async generateGuiaTiss(tipoGuiaTiss: 'GuiaTissInternacao' | 'GuiaTissOpme' = 'GuiaTissInternacao') {
    console.time('gerarGuiaTiss')
    const documentLoader = tipoGuiaTiss === 'GuiaTissInternacao' ? 'loadingGuiaTissInternacao' : 'loadingGuiaTissOpme'
    const documentName = tipoGuiaTiss === 'GuiaTissInternacao' ? 'Guia Tiss Internação' : 'Guia Tiss OPME'
    this[documentLoader] = true

    const request = await this.getBackofficeGlobalStore.getAllInformacoesParaGerarAGuiaTiss({
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      tipoDoTemplate: TipoDocumentoUpload[tipoGuiaTiss],
    })

    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: request.message ? `${request.message} ${String.fromCodePoint(0x1F615)}` : `Erro ao gerar guia tiss. ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this[documentLoader] = false
      return
    }

    this.$forceUpdate()

    const file = await this.handlePdfGeneration(
      documentName,
      this.$refs[tipoGuiaTiss === 'GuiaTissInternacao' ? 'guiaTissInternacao' : 'guiaTissOpme'],
      tipoGuiaTiss === 'GuiaTissOpme' ? 'landscape' : 'portrait',
    )

    const response = await this.inputFile({
      file,
      tipoDocumento: tipoGuiaTiss === 'GuiaTissInternacao' ? TipoDocumentoUpload.GuiaTissInternacao : TipoDocumentoUpload.GuiaTissOpme,
    })

    if (!response) {
      this[documentLoader] = false
      console.timeEnd('gerarGuiaTiss')
      return
    }

    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Guia Tiss de ${tipoGuiaTiss === 'GuiaTissInternacao' ? 'Internação' : 'OPME'} gerada com sucesso!! ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })

    this[documentLoader] = false
    this.getBackofficeGlobalStore.clearGuiaTissInternacaoOpme()
    console.timeEnd('gerarGuiaTiss')
  }

  async handlePdfGeneration(fileName: string = 'file', ref: any, pageOrientation: 'portrait' | 'landscape' = 'portrait') {
    const fileType = 'application/pdf'
    const tempContainer = document.createElement('div')
    tempContainer.style.position = 'absolute'
    tempContainer.style.top = '-9999px'
    tempContainer.style.left = '-9999px'

    document.body.appendChild(tempContainer)

    const TissComponent = ref

    TissComponent.$el.style.display = 'block'
    tempContainer.appendChild(TissComponent.$el)

    const TissContent = TissComponent.$el

    const blob = await pdfService.generateFromHtmlWithMultiplePages(TissContent, {
      orientation: pageOrientation,
      fileName,
      margin: 10,
      uploadFile: true,
    })

    document.body.removeChild(tempContainer)

    return blobToFile(blob as Blob, `${fileName}.pdf`, fileType)
  }

  async inputFile(data: any) {
    let response: boolean = false
    const formData = new FormData()
    formData.append('laudos', data.file)
    const request = await this.getBackofficeGlobalStore.upload({ formData, tipoDocumento: data.tipoDocumento })

    if ((request.data && request.data.length === 0) || !request.data) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: request.error ? `${request.error} ${String.fromCodePoint(0x1F615)}` : `'Erro ao armazenar arquivo. Tente novamente.' ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      return response
    }

    // Apaga a primeira versão de Guia Tiss, caso ela exista...
    const previousDoc = this.getBackofficeGlobalStore.solicitacao.laudos.filter(c => c.tipoDocumento === TipoDocumentoUpload[data.tipoDocumento])

    if (previousDoc.length > 0) {
      await this.getBackofficeGlobalStore.deleteLaudo({
        hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
        id: previousDoc[0].id,
      })
    }

    // Gerar o resumo mais uma vez...
    await this.getBackofficeGlobalStore.gerarResumo()
    // Busca a versão atualizada da solicitação...
    await this.getBackofficeGlobalStore.getSolicitacaoById(this.getBackofficeGlobalStore.solicitacao.id)
    response = true
    return response
  }

  get permiteGerarGuiaTISS() {
    const { solicitacao } = this.getBackofficeGlobalStore
    return solicitacao && solicitacao.acoes && solicitacao.acoes.permiteGerarGuiaTISS
  }

  get permiteGerarGuiaTissPeloFront() {
    const { solicitacao } = this.getBackofficeGlobalStore
    return solicitacao
      && solicitacao.acoes
      && solicitacao.acoes.permiteGerarGuiaTISS
      && solicitacao.hospital
      && solicitacao.hospital.hospitalGeraGuiaTissPeloFront
  }

  get hospitalHasEnabledTissSadtConfiguration() {
    const { template: hospitalTemplate } = this.getBackofficeGlobalStore
    return hospitalTemplate
      && hospitalTemplate.formulario
      && hospitalTemplate.formulario.anexo
      && hospitalTemplate.formulario.anexo.acoes
      && hospitalTemplate.formulario.anexo.acoes.permiteGerarGuiaTissSadt
  }
}
